import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import ContentLandingPageWrapper from '../Components/ContentLandingPageWrapper';
import ButtonGroup from '../Components/ButtonGroup';
import Button from '../Components/Button';
import Fonts from '../Styles/Fonts';
import Colors from '../Styles/Colors';

const DetailsTitle = styled.h2`
    ${Fonts.merriweather.bold};
    font-size: 19px;
    margin: 0;
    color: ${Colors.white};
    text-align: center;
`;
const AttendeeList = styled.div`
    margin-top: 5px;
`;
const AttendeeListItem = styled.div`
    font-size: 14px;
    display: flex;
    flex: 1 1 100%;
    background-color: ${props => props.odd ? 'transparent' : Colors.grayMedium};
    margin: 0 -14px;
    padding: 5px 14px 4px;
    color: ${Colors.white};
`;
const AttendeeListItemName = styled.div`
    display: flex;
    flex: 1 1 100%;
`;
const AttendeeListItemCompany = styled.div`
    display: flex;
    flex: 1 1 100%;
`;

class EventInfoAttendeesPage extends Component {
    componentDidMount = () => {
    };

    renderDetailsTitle = (group) => {
        let detailsTitle = "";
        switch (group) {
            case "general":
                detailsTitle = "General Agents";
                break;
            case "acic":
                detailsTitle = "Atlantic Casualty";
                break;
            default:
                break;
        }
        return (
            <DetailsTitle>{ detailsTitle }</DetailsTitle>
        )
    }

    renderAttendeeNamePosition = (attendee) => {
        if (attendee.position) {
            return (
                <React.Fragment>
                    { attendee.first_name } { attendee.last_name }<br />
                    { attendee.position.replace("&amp;", "&") }
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    { attendee.first_name } { attendee.last_name }
                </React.Fragment>
            );
        }
    }

    renderCompany = (attendee) => {
        if (attendee.company) {
            return attendee.company.replace("&amp;", "&");
        } else {
            return "";
        }
    }

    renderDetailsList = (group) => {
        if (this.props.content && this.props.content[group]) {
            const detailsList = this.props.content[group].map((attendee, index) => {
                return (
                    <AttendeeListItem key={index} odd={(index % 2) === 0}>
                        <AttendeeListItemName>{ this.renderAttendeeNamePosition(attendee) }</AttendeeListItemName>
                        <AttendeeListItemCompany>{ this.renderCompany(attendee) }</AttendeeListItemCompany>
                    </AttendeeListItem>
                );
            });
            return (
                <AttendeeList>
                    { detailsList }
                </AttendeeList>
            )
        } else {
            return null;
        }
    }

    renderDetails = (group) => {
        return (
            <ContentLandingPageWrapper headerTitle="Event Info" headerSubtitle="Attendees" fullWidth={true}>
                { this.renderDetailsTitle(group) }
                { this.renderDetailsList(group) }
            </ContentLandingPageWrapper>
        )
    }

    renderLanding = () => {
        return (
            <ContentLandingPageWrapper headerTitle="Event Info" headerSubtitle="Attendees">
                <ButtonGroup>
                    <Button to="/event-info/attendees/general">General Agents</Button>
                    <Button to="/event-info/attendees/acic">Atlantic Casualty</Button>
                </ButtonGroup>
            </ContentLandingPageWrapper>
        );
    }

    render() {
        const urlPathParts = this.props.location.pathname.replace(/\/+$/,'').split('/');
        const detailsUrl = urlPathParts[urlPathParts.length - 1];
        if (["general","acic"].indexOf(detailsUrl) > -1) {
            return this.renderDetails(detailsUrl);
        } else {
            return this.renderLanding();
        }
    }
}

const mapStateToProps = (state) => {
    return {
        content: state.content.eventInfoAttendeesContent
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        performDispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventInfoAttendeesPage));